import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faServer,
faSolarPanel} from "@fortawesome/free-solid-svg-icons";

library.add(
  faServer,faSolarPanel
);
